/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import classname from 'classnames';
import * as React from 'react';

export interface IAddressDetailItem {
    isNewLine: boolean;
    isShowLabel: boolean;
    labelText: string;
    name: string;
    value: string;
}

const AddressDetailItem: React.FC<IAddressDetailItem> = ({
    isNewLine,
    isShowLabel,
    labelText,
    name,
    value
}) => {
    const className = `msc-address-detail__item msc-address-detail__item-${name.toLowerCase()}`;
    const isEmpty = !(value && value.length > 0);
    const mainClass = isShowLabel ? `msc-address-detail__item msc-address-detail__item-address-detail_${labelText}` : classname(className, { 'msc-address-detail__item-empty': isEmpty, 'msc-address-detail__item-newline': isNewLine });
    value = (name.toLowerCase() === 'phone') ? _formatPhoneNumber(value) : value;
    return (
        <div className={mainClass}>
            {
                isShowLabel && <>
                    <span className={`${className}-label`}>{labelText}</span>
                    <span className={classname(className, { 'msc-address-detail__item-empty': isEmpty, 'msc-address-detail__item-newline': isNewLine })} aria-hidden={false} />
                </>
            }
            {value}
        </div>
    );
};

function _formatPhoneNumber(phoneNumberString: string): string {
    const cleaned = phoneNumberString.replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = (match[1] ? '+1-' : '');
        return [intlCode, match[2], '-', match[3], '-', match[4]].join('');
    }
    return '';
}

export default AddressDetailItem;
